<template>
  <div class="container">
    <div class="accept-terms">
      <input
        class="checkbox"
        type="checkbox"
        id="accept-terms"
        @click="checkRegulation"
      />
      <label class="checkbox" for="accept-terms">利用規約に同意</label>
    </div>

    <div style="width: 100%">
      <ItemButton
        :label="pageType == 'using' ? '利用開始する' : '予約する'"
        :isDisabled="!isChecked"
        actionType="disabled"
        @clicked="onClickButton"
      />
    </div>
  </div>

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" />

  <!-- 予約成功 -->
  <DialogReservationSuccessful ref="DialogReservationSuccessful" />

  <!-- 予約失敗 -->
  <DialogReservationFailure ref="DialogReservationFailure" />
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import API from "@/API";

export default {
  name: "DbsBookingBottomButton",
  props: {
    selectedCouponId: {
      type: Number,
      required: false,
      default: null,
    },
    pageType: {
      type: String, // using or booking
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const cycle = store.getters["dbs/cycle"];
    const isChecked = ref(false);

    const DialogLoading = ref(null);
    const DialogReservationSuccessful = ref(null);
    const DialogReservationFailure = ref(null);

    const checkRegulation = () => {
      var ele = document.getElementsByClassName("checkbox")[0];
      isChecked.value = ele.checked;
    };

    const onClickButton = async () => {
      try {
        DialogLoading.value.openDialog();

        const params = {
          cyc_name: cycle.cyc_name,
          coupon_pass_ids:
            props.selectedCouponId != null ? [props.selectedCouponId] : [],
        };
        await API.postDbsReservation(params);

        DialogLoading.value.closeDialog();

        // pageTypeに応じて次の画面へ
        if (props.pageType == "using") {
          // いますぐ使うの場合
          router.push({
            name: "DbsUnlocking",
            query: {
              cyc_csa_name: route.query.cyc_csa_name,
            },
          });
        } else {
          // 予約の場合
          DialogReservationSuccessful.value.openDialog();
        }
      } catch (e) {
        DialogLoading.value.closeDialog();
        DialogReservationFailure.value.openDialog();
      }
    };

    return {
      isChecked,
      checkRegulation,
      onClickButton,
      DialogLoading,
      DialogReservationSuccessful,
      DialogReservationFailure,
    };
  },
};
</script>
<style scoped>
.container {
  background-color: #ffb206;
  padding: 15px 15px 20px 15px;
}
.container .accept-terms {
  margin: 0 0 15px 0;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
}
.container button {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 30px;
  background-color: #ffffff;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-shadow: var(--defaultBoxShadow);
}
.container button:disabled {
  background-color: #e9e9e9;
  color: #999999;
}
</style>
